module.exports = __webpack_public_path__ + "static/media/group_pic4.36f0e5f3.jpg";